<template>
    <div
        class="settings-page container-fluid page-card admin-weflix-settings"
    >
        <div class="settings-tabs-card">
            <nav class="settings-tabs" aria-label="Seções de configurações">
                <div class="link">
                    <a
                        class="link-content"
                        :class="[isActiveTab(1) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(1)"
                        @keydown.enter.prevent="setActiveTab(1)"
                    >
                        Geral
                    </a>
                </div>
                <div class="link last">
                    <a
                        class="link-content"
                        :class="[isActiveTab(2) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(2)"
                        @keydown.enter.prevent="setActiveTab(2)"
                    >
                        Domínios
                    </a>
                </div>
            </nav>
        </div>

        <div class="settings-shell">
            <div class="settings-form-panel">
                <section
                    class="section config-form primary settings-section"
                    :class="[isActiveTab(1) ? 'active' : '']"
                >
                    <General />
                </section>
                <section
                    class="section config-form primary settings-section"
                    :class="[isActiveTab(2) ? 'active' : '']"
                >
                    <Domain />
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import General from '@/components/Weflix/Config/genereal.vue';
    import Domain from '@/components/Weflix/Config/domain.vue';
    import { mapActions } from 'vuex';

    export default {
        data() {
            return {
                activeTab: 1,
                hassaved: false,
                openmodalmodule: false,
            };
        },
        props: {},
        components: {
            General,
            Domain,
        },
        methods: {
            ...mapActions(['storeToken']),
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
            settoken(token) {
                this.storeToken({ token: token });
            },
        },
        created() {},
    };
</script>

<style scoped>
    @import url(./global.css);

    .settings-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .settings-tabs-card {
        padding: 1rem;
    }

    .settings-tabs {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .settings-tabs .link {
        flex: 0 0 auto;
    }

    .settings-tabs .link a.link-content {
        display: inline-block;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.4;
        color: #1a1d26;
        background: #eef0fc;
        text-decoration: none;
        padding: 0.5rem 1rem;
        border-radius: 10px;
        border: 1px solid transparent;
        cursor: pointer;
        transition:
            background 0.2s ease,
            color 0.2s ease,
            border-color 0.2s ease;
    }

    .settings-tabs .link a.link-content:hover {
        background: #e0e4fa;
        color: #250891;
    }

    .settings-tabs .link a.link-content.active {
        color: #fff;
        background: #250891;
        border-color: #250891;
    }

    .settings-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .settings-shell::-webkit-scrollbar {
        display: none;
    }

    .settings-form-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    .settings-section.section.config-form.primary {
        display: none;
        background: transparent;
        overflow-x: hidden;
    }

    .settings-section.section.config-form.primary.active {
        display: block;
        height: auto;
        overflow: visible;
    }

    /* Conteúdo Geral / Domínios dentro do painel */
    .settings-form-panel :deep(.generalConfig),
    .settings-form-panel :deep(.domainsConfig) {
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
    }

    .settings-form-panel :deep(.titlelayoutGeneric) {
        margin-bottom: 1rem !important;
        padding-bottom: 1rem !important;
        border-bottom: 1px solid #e8eaf0;
    }

    .settings-form-panel :deep(.titlelayoutGeneric.has-margin) {
        margin: 0 0 1rem !important;
    }

    .settings-form-panel :deep(.settings-panel.contetContainerEditVideo),
    .settings-form-panel :deep(.domain-settings-panel) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        padding: 1rem 1.25rem 1.25rem;
    }

    .settings-form-panel :deep(.actions.configGeneralWeflix) {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #e8eaf0;
        justify-content: flex-end;
    }

    @media (max-width: 600px) {
        .settings-tabs {
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            gap: 0.4rem;
            padding: 0.6rem;
        }

        .settings-tabs .link a.link-content {
            white-space: nowrap;
        }

        .settings-shell {
            padding: 0 1rem 1.25rem;
        }

        .settings-form-panel {
            padding: 1rem;
        }
    }
</style>
